import { AppDispatch } from '@src/store/store'
import { couponsApi } from '@src/api/coupons-api'
import {
  setCoupons, setIsLoading, setIsNext, setTotal,
} from '@src/store/ducks/coupons/reducer'

export const getCoupons = (page: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setIsLoading(true))

    const result = await couponsApi.getAll(page)

    dispatch(setCoupons(result.coupons))
    dispatch(setIsNext(result.next))
    dispatch(setTotal(result.total))
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
